import { BaseCommand } from './baseCommand';
import Element, { ElementType } from '../element';
import { BaseTexture, PBRMetallicRoughnessMaterial, Material, Texture } from '@babylonjs/core';
import { IShader } from '../shaders/shader';
import store from '@/store';

export class ChangeRafixColorCommand extends BaseCommand {

    private previousColors: Map<Element, BaseTexture> = new Map();
    private previousShader!: IShader;
    private mutation!: string;

    constructor(
        scenePreview: any,
        protected elements: Element[],
        private shader: IShader,
        private onStart: () => void,
        private onFinish: () => void,
    ) {
        super(scenePreview);
        this.savePreviousColors();
    }

    public execute() {
        this.onStart();
        this.manageShaders();
        this.applyMaterial();
    }

    public revert() {
        this.revertCommands();
        this.previousColors.forEach((texture, element) => {
            this.applyTexture(element, texture);
        });
        store.commit(this.mutation, this.previousShader);
    }

    private manageShaders() {
        if(this.elements.length) {
            const type = this.elements[0].type;
            switch (type) {
                case ElementType.WALL: {
                    this.previousShader = store.getters.shaders.selectedRafix;
                    this.mutation = 'selectRafix';
                    store.commit(this.mutation, this.shader);
                }
            }
        }
    }

    private applyMaterial() {
        const material = this.shader.getMaterial(this.scenePreview.scene, '');
        if (material instanceof PBRMetallicRoughnessMaterial) {
            (material.baseTexture as Texture).onLoadObservable.add(() => {
                this.elements.forEach((element) => {
                    const texture = this.getTexture(material);
                    this.applyTexture(element, texture);
                });
                this.onFinish();
            });
        }
    }

    private applyTexture(element: Element, texture: BaseTexture) {
        element.meshes.forEach((mesh) => {
            if (mesh.material instanceof PBRMetallicRoughnessMaterial &&
                mesh.name.includes('rafix')) {
                mesh.material.baseTexture = texture;
            }
        });
    }

    private savePreviousColors() {
        this.elements.forEach((element) => {
            const mesh = element.meshes.find((x) => x.name.includes('rafix'))!;
            const texture = this.getTexture(mesh.material!);
            this.previousColors.set(element, texture);
        });
    }

    private getTexture(material: Material): BaseTexture {
        const m = material as PBRMetallicRoughnessMaterial;
        const baseTexture = m.baseTexture;
        return baseTexture;
    }
}
